/*
 * @Author: zhengshuhua
 * @Date: 2021-09-14 09:24:25
 * @LastEditors: zhengshuhua
 * @LastEditTime: 2022-01-17 11:03:44
 * @Description: file content
 * @FilePath: \edc-web\src\directive\authorizeFunction\authorizeFunction.js
 */
export function hasUserType(code, roleList) {
	// 默认是没有权限显示的
	let result = null
	if (roleList) {
		result = roleList.find(item => {
			return item === code
		})
	}
	return !!result
}
